import { render, staticRenderFns } from "./Shortlisted.vue?vue&type=template&id=0193481f"
import script from "./Shortlisted.vue?vue&type=script&lang=js"
export * from "./Shortlisted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports